import { buildSanityImageUrl } from '@lib/sanity';
import type { SanityAuthor } from '@lib/sanity';

const AVATAR_WIDTH = 76;

/** The round byline photo; a grey disc stands in when the author has none. */
export const AuthorAvatar = ({
  author
}: {
  author: Pick<SanityAuthor, 'avatar'>;
}) => (
  <span className="h-[38px] w-[38px] shrink-0 overflow-hidden rounded-full bg-[#dfe4e8]">
    {author.avatar?.asset && (
      <img
        src={buildSanityImageUrl(author.avatar)
          .width(AVATAR_WIDTH)
          .height(AVATAR_WIDTH)
          .url()}
        alt=""
        className="h-full w-full object-cover"
      />
    )}
  </span>
);
